// extracted by mini-css-extract-plugin
export var author = "tags-module--author--fc818";
export var category = "tags-module--category--27de2";
export var headline = "tags-module--headline--31549";
export var headlinePost = "tags-module--headline-post--83ff8";
export var paragraph = "tags-module--paragraph--b6f9b";
export var tag = "tags-module--tag--7bc7e";
export var tags = "tags-module--tags--a1fc3";